var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon20Fd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5871 2.00325L12.4468 2C10.0423 2 8.48845 3.50837 8.48845 5.84297V7.61483H6.33653C6.15058 7.61483 6 7.75747 6 7.9334V10.5006C6 10.6766 6.15075 10.819 6.33653 10.819H8.48845V17.297C8.48845 17.4729 8.63903 17.6154 8.82498 17.6154H11.6326C11.8186 17.6154 11.9692 17.4728 11.9692 17.297V10.819H14.4852C14.6712 10.819 14.8218 10.6766 14.8218 10.5006L14.8228 7.9334C14.8228 7.84893 14.7873 7.76803 14.7242 7.70824C14.6612 7.64846 14.5754 7.61483 14.4861 7.61483H11.9692V6.1128C11.9692 5.39086 12.151 5.02437 13.145 5.02437L14.5867 5.02388C14.7725 5.02388 14.9231 4.88125 14.9231 4.70548V2.32166C14.9231 2.14604 14.7727 2.00357 14.5871 2.00325Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20Fd);
export default __webpack_public_path__ + "static/media/icon--20-fd.adda9ffa.svg";
export { ForwardRef as ReactComponent };